import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Play, Clock, FileVideo } from "lucide-react";
import styles from "./VideoCard.module.css";

interface VideoCardProps {
  title: string;
  duration: string;
  size: string;
  step?: string;
  isLocked?: boolean;
  onClick?: () => void;
}

// Custom Card Component
const Card = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => {
  return <div className={`${styles.videoCard} ${className}`}>{children}</div>;
};

// Custom CardContent Component  
const CardContent = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => {
  return <div className={`${styles.cardContent} ${className}`}>{children}</div>;
};

// Custom Badge Component
const Badge = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => {
  return <span className={`${styles.badge} ${className}`}>{children}</span>;
};

// Custom Button Component
const Button = ({ 
  children, 
  onClick, 
  disabled , 
  className = "" 
}: { 
  children: React.ReactNode; 
  onClick?: () => void; 
  disabled?: boolean;
  className?: string;
}) => {
  return (
    <button 
      className={`${styles.button} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

const VideoCard = ({ title, duration, size, step, isLocked , onClick }: VideoCardProps) => {
 const navigate = useNavigate();
  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (!userData) {
      navigate('/');
      return;
    }
    try {
      const user = JSON.parse(userData);
      if (user.status !== 'succeeded') {
        navigate('/');
      }
    } catch {
      navigate('/');
    }
  }, [navigate]);

  return (
    <Card>
      <CardContent>
        <div className={styles.cardHeader}>
          <div className={styles.iconContainer}>
            <div className={styles.iconWrapper}>
              <FileVideo className={styles.icon} />
            </div>
            {step && (
              <Badge>
                {step}
              </Badge>
            )}
          </div>
          <div className={styles.fileSize}>{size}</div>
        </div>

        <h3 className={styles.title}>
          {title}
        </h3>

        <div className={styles.durationContainer}>
          <Clock className={styles.durationIcon} />
          <span>{duration}</span>
        </div>

        <Button 
          onClick={onClick}
          disabled={isLocked}
        >
          <Play className={styles.buttonIcon} />
          {isLocked ? "Premium Content" : "Watch Now"}
        </Button>

        {/* Glow effect */}
        {/* <div className={styles.glowEffect} /> */}
      </CardContent>
    </Card>
  );
};

export default VideoCard;